import Banner from "@/components/landing/privacyPolicy/Banner";
import PrivacyConten from "@/components/landing/privacyPolicy/PrivacyConten";

export default function PrivacyPolicy() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Privacy Conten section */}
      <PrivacyConten />
    </>
  );
}
